export default class ScrollOffset {
    constructor(el) {
        this.el = el;
        this.el.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(e) {
        e.preventDefault();
        const target = document.querySelector(e.target.getAttribute('href'));
        const offset = document.querySelector('[data-menu-header]').offsetHeight || 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset - 20;

        window.scrollTo({
            top,
            behavior: 'smooth'
        });
    }
}